// extracted by mini-css-extract-plugin
module.exports = {"sectionPill":"style-module__sectionPill___2MIPP","active":"style-module__active___RsxsB"};